import ScoreCategory from "./ScoreCategory";
import { Scores } from "@local-logic/client";
import { TrackingEvents, ProductNames } from "@local-logic/core/tracking";
import { scoreCategories } from "@local-logic/elements-react";
import * as Accordion from "@radix-ui/react-accordion";
import React, { useEffect, useState } from "react";
import { useTracking } from "~/context/trackingProvider";
import useIsMobile from "~/hooks/useIsMobile";
import { useLocalContent } from "~/sdks/LocalContent/context";

const ScoreCategoryAccordion = React.memo(
  ({ tabContent }: { tabContent: (typeof scoreCategories)[number] }) => {
    const { activeScore, setActiveScore } = useLocalContent();
    const tracking = useTracking();
    const isMobile = useIsMobile();

    const [isScoreClicked, setIsScoreClicked] = useState(false);

    useEffect(() => {
      setActiveScore(tabContent.scores[0]);
    }, []);

    useEffect(() => {
      if (isScoreClicked) {
        tracking.postEvent({
          eventType: TrackingEvents.LOCALCONTENT_SCORE_CLICKED,
          product: ProductNames.LOCAL_CONTENT,
          isMobile,
          eventAttributes: [
            {
              label: "activeScore",
              data: activeScore.toString(),
            },
          ],
        });
      }

      return () => {
        setIsScoreClicked(false);
      };
    }, [isScoreClicked]);

    useEffect(() => {
      tracking.postEvent({
        eventType: TrackingEvents.LOCALCONTENT_SCORE_VIEWED,
        product: ProductNames.LOCAL_CONTENT,
        isMobile,
        eventAttributes: [
          {
            label: "activeScore",
            data: activeScore.toString(),
          },
        ],
      });
    }, [activeScore]);

    return (
      <Accordion.Root
        value={activeScore}
        onValueChange={(v) => {
          setActiveScore(v as keyof Scores["location"]);
          setIsScoreClicked(true);
        }}
        type="single"
        collapsible
      >
        <ScoreCategory tabContent={tabContent} />
      </Accordion.Root>
    );
  }
);

ScoreCategoryAccordion.displayName = "ScoreCategoryAccordion";

export default ScoreCategoryAccordion;
